import React from 'react'
import WizardButton from '../../wizard-v2/components/WizardButton'
import { createPortal } from 'react-dom';
import GroupBookingBigGroup from '../../groupBooking/GroupBookingBigGroup';
import { BIG_GROUP_CLICK } from '../../../constants/analyticEvents';
import { pushEvent } from '../../../utilities/analytics';
import { t } from '../../../utilities/translator';
import abTesting from '../../../services/abTesting';
import { BIG_GROUP_LINK } from '../../../constants/constants';

const AdultsStepDesktop = ({
  data,
  form,
  onCardClick,
  selectedType,
  onPlusClicked,
  plusButtonClicked,
  onContinueClick,
  allowBigGroupTxt,
}) => {
  const footerPortal = document.getElementById('wizard-next-button');

  return (
    <div className="adults-step">
      <p className="mb-8 heading-large text-primary">{selectedType === 'friends' ? data.adultsSelection.friendsTitle : data.adultsSelection.familyTitle}</p>
      <div className="flex items-center justify-center gap-6">
        {selectedType === 'family' && (
          <WizardButton
            label={1}
            className="w-[120px] h-[120px] slide-in-bottom animation-delay-0 font-semibold text-primary text-lg"
            active={form.who?.capacity?.adults === 1}
            onClick={onCardClick(1)}
          />
        )}
        <WizardButton
          label={2}
          className="w-[120px] h-[120px] slide-in-bottom animation-delay-100 font-semibold text-primary text-lg"
          active={form.who?.capacity?.adults === 2}
          onClick={onCardClick(2)}
        />
        <WizardButton
          label={3}
          className="w-[120px] h-[120px] slide-in-bottom animation-delay-200 font-semibold text-primary text-lg"
          active={form.who?.capacity?.adults === 3}
          onClick={onCardClick(3)}
        />
        {(selectedType === 'friends' || selectedType === 'family') && (
          <WizardButton
            label="+"
            className="w-[120px] h-[120px] slide-in-bottom animation-delay-300 font-normal text-tertiary text-[26px]"
            onClick={() => onPlusClicked()}
            disabled={plusButtonClicked}
          />
        )}
      </div>
      {plusButtonClicked && !abTesting.groupBooking && (
        <div className="wizard-limit-message">
          {data.adultsSelection.moreThanAllowedText}
        </div>
      )}

      {(plusButtonClicked && allowBigGroupTxt && !abTesting.groupBooking) && (
        <div className="p-4 bg-info-light text-center scale-in-center flex items-center justify-center gap-3 absolute bottom-0 left-0">
          <span className="label-large leading-none text-[15px]">{t('mainFilter.who.bigGroupTitle')}</span>
          <span className="body-medium font-medium leading-4" onClick={() => { pushEvent(BIG_GROUP_CLICK, { type: 'wizard_desktop' }); }} dangerouslySetInnerHTML={{ __html: t('mainFilter.who.bigGroupText', { link: BIG_GROUP_LINK }) }} />
        </div>
      )}

      {plusButtonClicked && abTesting.groupBooking && (
        <GroupBookingBigGroup isDesktopWizard />
      )}

      {footerPortal && createPortal(
        <button className="wizard-btn wizard-btn--next" onClick={onContinueClick} disabled={!form.who?.capacity?.adults}>
          {data.buttonText}
          <i className="ri-arrow-right-s-line text-xl leading-none rtl:-scale-x-100" />
        </button>,
        footerPortal
      )}
    </div>
  )
}

export default AdultsStepDesktop
